import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-4">
            {contactInfo.title}
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
            {contactInfo.subtitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
            {contactInfo.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactInfo.ways.map((way) => (
              <div
                key={way.label}
                className="bg-background-100/80 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-colors"
              >
                <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl mb-4">
                  <i className={`${way.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="text-sm font-semibold text-foreground-900 mb-1">{way.label}</div>
                <div className="text-sm text-primary-600 font-medium break-all">{way.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}